<template>
	<div class="gk_corpus">		
		<div>
			<h3 class="mb-3">ЖК "{{this.ApiData.gk_name}}", регион gk_region_id {{this.ApiData.gk_region_id}}, sold: {{this.ApiData.sold}}</h3>	
			<h3>Застройщик: {{this.ApiData.dev_name}}</h3>	
		</div>
		<div>
			<h4>фильтр для справочников по regionId</h4>
			<h4>cat_nb_yandex.length: {{this.cat_nb_yandex.length}}</h4>	
			<h4>cat_nb_avito.length: {{this.cat_nb_avito.length}}</h4>	
			<h4>cat_nb_cian.length: {{this.cat_nb_cian.length}}</h4>	
		</div>
		<card class="">
			<el-table ref="multipleTable" 
				:data="this.gk_corpus"
				v-loading.fullscreen.lock="$GVO.fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"	
				>
				
				<!-- <el-table-column
					width="280"
					label="block_tree"
					type="block_tree"
				>
					<template slot-scope="scope">
						{{ scope.row.block_tree}}
					</template>
				</el-table-column>			 -->
				<el-table-column
					min-width="55"
					sortable
					label="name"
					property="name"
				></el-table-column>			
				<el-table-column
					min-width="140"
					sortable
					label="value"
					property="value"
				></el-table-column>			
				<el-table-column
					min-width="155"
					label="Яндекс"
					property="gk_name_tr"
				>
					<template v-slot="scope">
						<!-- <el-select 
							class="col-md px-0 select-primary"
							v-model="nb_yandex" 
							placeholder="Выбрать ЖК"
							size="large"
							filterable
							clearable
						>
							<el-option
								class="select-primary"
								v-for="item in cat_nb_yandex"
								:key="item.id"
								:label="item.name"
								:value="item.id"
								>
							</el-option>
						</el-select> -->
						<el-select 
							class="col-md px-0 select-primary"
							v-model="corpusData.nb_yandex" 
							placeholder="Выбрать ЖК"
							size="large"
							filterable
							clearable
							remote
							:remote-method="remoteMethod_yandex"
							:loading="loading"
						>
							<el-option
								class="select-primary"
								v-for="item in options_yandex"
								:key="item.id"
								:label="item.name"
								:value="item.id"
								>
							</el-option>
						</el-select>

					</template>
				</el-table-column>
				<el-table-column
					min-width="155"
					label="Авито"
					property="gk_name_tr"
				>
					<template v-slot="scope">

						<el-select 
							class="col-md px-0 select-primary"
							v-model="corpusData.nb_avito" 
							placeholder="Выбрать ЖК"
							size="large"
							filterable
							clearable
							remote
							:remote-method="remoteMethod_avito"
							:loading="loading"
						>
							<el-option
								class="select-primary"
								v-for="item in options_avito"
								:key="item.id"
								:label="item.name"
								:value="item.id"
								>
							</el-option>
						</el-select>

					</template>
				</el-table-column>
				<el-table-column
					min-width="155"
					label="ЦИАН"
					property="gk_name_tr"
				>
					<template v-slot="scope">

						<el-select 
							class="col-md px-0 select-primary"
							v-model="corpusData.nb_cian" 
							placeholder="Выбрать ЖК"
							size="large"
							filterable
							clearable
							remote
							:remote-method="remoteMethod_cian"
							:loading="loading"
						>
							<el-option
								class="select-primary"
								v-for="item in options_cian"
								:key="item.id"
								:label="item.name"
								:value="item.id"
								>
							</el-option>
						</el-select>

					</template>
				</el-table-column>


				<el-table-column
					min-width="155"
					label=""
					property="gk_name_tr"
					align="right"
				>
					<template v-slot="scope">
						<base-button type="primary" class="my-0" simple @click="sendData(scope.row)">Сохранить</base-button>
					</template>
				</el-table-column>
				<!-- <el-table-column
					min-width="155"
					label=""
					property="gk_name_tr"
					align="right"
				>
					<template slot-scope="scope">
						<base-button type="primary" class="my-0" simple @click="GoToGk(scope.row.gk_name_tr)">Редактировать</base-button>
					</template>
				</el-table-column> -->
					
			</el-table>

			
		</card>
	</div>
</template>

<script>
// import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn, Select, Option, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';

export default {
	name: 'gk_corpus-page',
	components: {
		// BaseSwitch,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button
	},
	props: {
		counter: String,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		// value: {
		// 	type: Object,
		// 	default: function() {
		// 		return {
		// 		// nb_yandex:'',
		// 		// nb_avito:'',
		// 		// nb_cian:'',
		// 		};
		// 	}
		// },
	},
	data() {
		return {
			ApiData: [],
			// b_corps_name: {},
			gk_corpus: [],
			cat_nb_yandex: [],
			cat_nb_avito: [],
			cat_nb_cian: [],
			nb_yandex: '',
			nb_avito: '',
			nb_cian: '',
			c2p: 100,
			loading: false,
			options_yandex: [],
			options_avito: [],
			options_cian: [],
			corpusData: {nb_yandex:'', nb_avito: '', nb_cian: '', gk_corpus:''}, //gk_corpus взять из row
		};
	},
	methods: {
		sendData(row){
			// if(corpusData){

			// }
			// console.log(row);
		},
		remoteMethod_yandex(query) {
			if (query !== '') {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
				this.options_yandex = this.cat_nb_yandex.filter(item => {
				return item.name.toLowerCase()
					.indexOf(query.toLowerCase()) > -1;
				});
			}, 200);
			} else {
			this.options_yandex = [];
			}
		},
		remoteMethod_avito(query) {
			if (query !== '') {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
				this.options_avito= this.cat_nb_avito.filter(item => {
				return item.name.toLowerCase()
					.indexOf(query.toLowerCase()) > -1;
				});
			}, 200);
			} else {
			this.options_avito = [];
			}
		},
		remoteMethod_cian(query) {
			if (query !== '') {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
				this.options_cian = this.cat_nb_cian.filter(item => {
				return item.name.toLowerCase()
					.indexOf(query.toLowerCase()) > -1;
				});
			}, 200);
			} else {
			this.options_cian = [];
			}
		},
		getApiData(){
			// this.$GVO.ApiCall('GET',{obj:'template'})
			// .then((objApi) => {
			// 	if(objApi.success === true){
			// 	if(objApi.data.length > 0){
			// 		this.ApiData = objApi.data;
			// 	}
			// 	}
			// }).catch(errorObjApi => console.log(errorObjApi));
			let gk_name_tr = this.$route.params.gk_name_tr;

			this.$GVO.ApiCall('GET_COMPLEX',{obj:'NovoObj',flt:{'gk_name_tr':gk_name_tr, }})
			.then((objApi) => {
				if(objApi.success === true){
					// console.log(objApi.data);
				let b_corps_name = {};
				if(objApi.data.length > 0){
					this.ApiData = objApi.data[0];
					
					b_corps_name =  JSON.parse(objApi.data[0].b_corps_name);//.map(v=>((v.private=v.public=='0'),v));
					// console.log(this.ApiData );
					Object.keys(b_corps_name).forEach((key)=>{
						this.gk_corpus.push({value:key, name:b_corps_name[key], });
					});
					// console.log("getApiData");
					// if(objApi.total!=undefined) {this.masObjects_total=objApi.total.countpage;}



					if(this.ApiData && !this.$GVO.isEmpty(this.ApiData)){
						// console.log("ApiData", this.ApiData);

						this.$GVO.ApiCall('cat.GET',{flt:{cat_name:"cat_nb_yandex", regionId: this.ApiData.gk_region_id, }},{"useCache":true})
							.then((objApi) => {
								this.cat_nb_yandex = [];
								// console.log("objApi", objApi);
								if(objApi.success === true){
									// console.log("objApi.data", objApi.data);
									if(objApi.data.length > 0){
										this.cat_nb_yandex = objApi.data;
										// console.log("cat_nb_yandex");
									}
								}else {this.cat_nb_yandex = [];}
							})
							.catch(errorObjApi => {this.cat_nb_yandex = []; console.error(errorObjApi); });

							this.$GVO.ApiCall('cat.GET',{flt:{cat_name:"cat_nb_avito", regionId: this.ApiData.gk_region_id}},{"useCache":true})
							.then((objApi) => {
								// this.cat_nb_avito = [];
								if(objApi.success === true){
									if(objApi.data.length > 0){
										this.cat_nb_avito = objApi.data;
									}
								}else {this.cat_nb_avito = [];}
							})
							.catch(errorObjApi => {this.cat_nb_avito = []; console.error(errorObjApi); });

							this.$GVO.ApiCall('cat.GET',{flt:{cat_name:"cat_nb_cian", regionId: this.ApiData.gk_region_id}},{"useCache":true})
							.then((objApi) => {
								// this.cat_nb_cian = [];
								if(objApi.success === true){
									if(objApi.data.length > 0){
										this.cat_nb_cian = objApi.data;
									}
								}else {this.cat_nb_cian = [];}
							})
							.catch(errorObjApi => {this.cat_nb_cian = []; console.error(errorObjApi); });

					}

				}
				}else {
					this.ApiData = [];
					this.b_corps_name = {};
					// this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		
		
	},
	mounted() {

			// this.$GVO.LoadCatPromise('cat_nb_yandex')
			// .then((objApi) => {
			// 	this.cat_nb_yandex = [];
			// 	for (let i = 0; i < this.$GVO.cats.cat_nb_yandex.length; i++) {
			// 		const element = this.$GVO.cats.cat_nb_yandex[i];
			// 		this.cat_nb_yandex.push({'regionId':element.regionId,'label':element.name, 'id':element.id});
			// 	}
			// })
			// .catch(errorObjApi => {console.log(errorObjApi); });

			this.getApiData();

								// if(typeof this.$GVO.cats.cat_nb_yandex == 'undefined'){
						// 	this.$GVO.ApiCall('cat.GET',{flt:{cat_name:"cat_nb_yandex", regionId: this.ApiData.gk_region_id}},{"useCache":true})
						// 	.then((objApi) => {
						// 		// this.cat_nb_yandex = [];
								
						// 		if(objApi.success === true){
						// 			console.log("objApi.data", objApi.data);
						// 			if(objApi.data.length > 0){
						// 				this.cat_nb_yandex = objApi.data;
						// 				console.log("cat_nb_yandex");
						// 			}
						// 		}else {this.cat_nb_yandex = [];}
						// 	})
						// 	.catch(errorObjApi => {this.cat_nb_yandex = []; console.log(errorObjApi); });
						// 	}else{
						// 		this.cat_nb_yandex = [];
						// 		for (let i = 0; i < this.$GVO.cats.cat_nb_yandex.length; i++) {
						// 			const element = this.$GVO.cats.cat_nb_yandex[i];
						// 			this.cat_nb_yandex.push({'regionId':element.regionId,'label':element.name, 'id':element.id});
						// 		}
						// }


						// if(typeof this.$GVO.cats.cat_nb_avito == 'undefined'){
						// 	this.$GVO.ApiCall('cat.GET',{flt:{cat_name:"cat_nb_avito", regionId: this.ApiData.gk_region_id}},{"useCache":true})
						// 	.then((objApi) => {
						// 		// this.cat_nb_avito = [];
						// 		if(objApi.success === true){
						// 			if(objApi.data.length > 0){
						// 				this.cat_nb_avito = objApi.data;
						// 			}
						// 		}else {this.cat_nb_avito = [];}
						// 	})
						// 	.catch(errorObjApi => {this.cat_nb_avito = []; console.log(errorObjApi); });
						// }else{
						// 	this.cat_nb_avito = [];
						// 	for (let i = 0; i < this.$GVO.cats.cat_nb_avito.length; i++) {
						// 		const element = this.$GVO.cats.cat_nb_avito[i];
						// 		this.cat_nb_avito.push({'regionId':element.regionId,'label':element.name, 'id':element.id});
						// 	}
						// }

						// if(typeof this.$GVO.cats.cat_nb_cian == 'undefined'){
						// 	this.$GVO.ApiCall('cat.GET',{flt:{cat_name:"cat_nb_cian", regionId: this.ApiData.gk_region_id}},{"useCache":true})
						// 	.then((objApi) => {
						// 		// this.cat_nb_cian = [];
						// 		if(objApi.success === true){
						// 			if(objApi.data.length > 0){
						// 				this.cat_nb_cian = objApi.data;
						// 			}
						// 		}else {this.cat_nb_cian = [];}
						// 	})
						// 	.catch(errorObjApi => {this.cat_nb_cian = []; console.log(errorObjApi); });
						// }else{
						// 	this.cat_nb_cian = [];
						// 	for (let i = 0; i < this.$GVO.cats.cat_nb_cian.length; i++) {
						// 		const element = this.$GVO.cats.cat_nb_cian[i];
						// 		this.cat_nb_cian.push({'regionId':element.regionId,'label':element.name, 'id':element.id});
						// 	}
						// }
	}
};
</script>

<style scoped>

</style>
